// Attendance continuation is a destination only, never an authorization token.
export function safeAttendanceReturn(value) {
  return typeof value === 'string' &&
    (value === '/attendance' || value === '/history' ||
      /^\/(?:attendance|history)\?reminder=[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        value,
      ))
    ? value.replace(/^\/attendance/, '/history')
    : null;
}
export function currentAttendanceReturn() {
  const url = new URL(location.href);
  return (
    safeAttendanceReturn(url.pathname + url.search) ||
    safeAttendanceReturn(url.searchParams.get('return_to'))
  );
}
